import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormField } from '../Generic'
import { BetriebsstelleField, BetriebsstellenartField } from '../../form'
import { useTranslation } from 'react-i18next'
import { Befehl31FormData } from './schema'
import { useMemo } from 'react'
import BorderedBox from '../Generic/BorderedBox'
import ZugmeldestelleWrapper from '../Generic/ZugmeldestelleWrapper'

export interface Feld31_13FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
  errors?: FieldErrors
}

export default function Feld31_13Form({
  readOnly,
  'data-testid': testId,
  errors,
  activateEmptyFieldWarnings = false
}: Readonly<Feld31_13FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const formContext = useFormContext<Befehl31FormData>()
  const { control, watch, formState } = formContext

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const selectorArt = watch('auftrag_31_10.feld31_13.art')

  return (
    <BorderedBox
      data-testid={`${testId}-bordered-box`}
      footer={
        <span data-testid={`${testId}-label`}>
          {t('befehle.31.label.feld31_13')}
        </span>
      }
    >
      <ZugmeldestelleWrapper
        betriebsstellenartField={
          <BefehlFormField
            name={'auftrag_31_10.feld31_13.art'}
            control={control}
            label="Betriebsstellenart"
            readOnly={readOnly}
            disabled={false}
            activateEmptyWarning={activateEmptyFieldWarnings}
            useTextDisplayInReadOnly={true}
            data-testid={`${testId}-art`}
            render={({ field, isDisabled, isReadOnly }) => (
              <BetriebsstellenartField
                {...field}
                label={t('befehle.31.text.betriebsstellenart')}
                variant="solid"
                selectClassName="w-full"
                errors={fieldErrors}
                disabled={isDisabled}
                readOnly={isReadOnly}
                data-testid={`${testId}-art-inner`}
              />
            )}
          />
        }
        bestriebsstelleField={
          <BefehlFormField
            name={'auftrag_31_10.feld31_13.name'}
            control={control}
            label={t('befehle.31.text.zugmeldestelle')}
            readOnly={readOnly}
            disabled={false}
            activateEmptyWarning={activateEmptyFieldWarnings}
            useTextDisplayInReadOnly={true}
            data-testid={`${testId}-name`}
            render={({ field, isDisabled, isReadOnly }) => (
              <BetriebsstelleField
                {...field}
                label={t('befehle.31.text.zugmeldestelle')}
                errors={fieldErrors}
                disabled={isDisabled}
                readOnly={isReadOnly}
                typ={selectorArt}
                data-testid={`${testId}-name-inner`}
              />
            )}
          />
        }
      />
    </BorderedBox>
  )
}
